import { fetchApi } from "./fetchApi";

export const featureFlagApi = {
  async get() {
    const response = await fetchApi({ method: "get", url: `/api/featureFlag` });

    return response.data.result;
  },
};
